import { useEffect, useState } from 'react';
import db, { collection, query, where, getDocs } from '../firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import { articleAppliesTo } from '../utils/helpCentre';

// Published help articles that apply to this tenant (academy or agency).
// Fetched once per page load and shared — they change rarely, and the
// Help panel and Help page both use them. The where() on status is what
// firestore.rules' helpArticles read rule needs for a list query.
let cache = null;
let pending = null;

function loadPublished() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = getDocs(query(collection(db, 'helpArticles'), where('status', '==', 'published')))
      .then((snap) => {
        cache = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        return cache;
      })
      .finally(() => { pending = null; });
  }
  return pending;
}

export function useHelpArticles() {
  const { isAgencyTenant } = useAuth();
  const [articles, setArticles] = useState(cache);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    loadPublished()
      .then((list) => { if (live) setArticles(list); })
      .catch((err) => { if (live) setError(err.message || 'Could not load the guides.'); });
    return () => { live = false; };
  }, []);

  return {
    articles: articles ? articles.filter((a) => articleAppliesTo(a, isAgencyTenant)) : [],
    loading: !articles && !error,
    error,
  };
}
